import React, { Component } from 'react';
import { Form, Modal, Button, Select, DatePicker, message, Icon, InputNumber } from 'antd';
import API_URL from '../../common/url';
import moment from 'moment'
import AjaxRequest from '../../common/AjaxRequest';

const FormItem = Form.Item;
const Option = Select.Option;
const { MonthPicker } = DatePicker;
const monthFormat = 'YYYY.MM';

class CreateForm extends Component {
    state = {
        investigationSiteName: '',
        investigationSiteCode: '',
        mode: this.props.mode,
        noFte: this.props.noFte,
        selectUserList: [],
        addSelect: '',
    }

    componentDidMount() {
        this.setState({
            addSelect: this.props.addSelect
        })
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            addSelect: nextProps.addSelect
        })
    }

    setFieldsValue = obj => {
        this.props.form.setFieldsValue(obj);
    }

    getEvent = () => {
        if (document.all) {
            return window.event;
        }
        let func = getEvent().caller;
        while (func != null) {
            var arg0 = func.arguments[0];
            if (arg0) {
                if ((arg0.constructor == Event || arg0.constructor == MouseEvent) || (typeof (arg0) == "object" && arg0.preventDefault && arg0.stopPropagation)) {
                    return arg0;
                }
            }
            func = func.caller;
        }
        return null;
    }

    add = () => {
        const { form } = this.props;
        let keys = form.getFieldValue('keys');
        const startMonthTemp = form.getFieldValue('startMonth');
        if (!startMonthTemp) {
            Modal.error({ title: `请输入起始时间` })
        }
        const endMonth = form.getFieldValue('endMonth');
        const setFteNum = form.getFieldValue('setFteNum');
        const fteArr = form.getFieldValue('fteArr');
        const getArrIndex = (date) => {
            let arrIndex = -1;
            fteArr.map((value, index) => {
                if (value !== 1)
                    if (value[0].format('YYYY-MM') == date) {
                        arrIndex = index
                    }
            })
            return arrIndex;
        }
        if (startMonthTemp && endMonth) {
            const startMonth = moment(moment(startMonthTemp).format("YYYY-MM"));
            const formatEndMonth = moment(moment(endMonth).format("YYYY-MM"))
            while (formatEndMonth >= startMonth) {
                const arrIndex = getArrIndex(startMonth.format('YYYY-MM'));
                if (arrIndex < 0) {
                    fteArr.push([moment(startMonth.format('YYYY-MM')), setFteNum]);
                } else {
                    fteArr[arrIndex][1] = setFteNum;
                }
                startMonth.add(1, 'month');
            }
        } else if (startMonthTemp) {
            const arrIndex = getArrIndex(startMonthTemp.format('YYYY-MM'));
            if (arrIndex < 0) {
                fteArr.push([moment(startMonthTemp.format('YYYY-MM')), setFteNum]);
            } else {
                fteArr[arrIndex][1] = setFteNum;
            }
        }
        const sortDate = (a, b) => {
            if (b !== 1 && a !== 1) {
                return a[0].format('X') - b[0].format('X')
            }

        }
        const fteArrSort = fteArr.sort(sortDate);
        form.setFieldsValue({
            fteArr: fteArrSort,
            keys: Number(keys) + 1
        });
    }

    componentDidMount() {
        const { form, role, fteList } = this.props;
        let keys = [];
        let fteArr = [];
        fteList.map((dataItem, i) => {
            if (dataItem.fte === "" || dataItem.fte === null || dataItem.fte === undefined) {
                return;
            }
            keys.push(i);
            let year = dataItem.year;
            let month = dataItem.month < 10 ? `0${dataItem.month}` : dataItem.month;
            fteArr.push([moment(`${year}-${month}`), dataItem.fte]);
        });

        form.setFieldsValue({
            fteArr
        });

        let siteId;
        if (sessionStorage.siteId != null && sessionStorage.siteId != 0) {
            siteId = sessionStorage.siteId;
        } else {
            const { form } = this.props;
            siteId = form.getFieldValue('invSiteId');
        }
        if (siteId != null && siteId != 0) {
            const options = {
                url: `${API_URL.site.queryBySiteId}?investigationSiteId=${siteId}`,
                dataType: 'json',
                data: {
                    roleCode: role,
                },
                doneResult: data => {
                    this.setState({
                        city: data.data.site.city,
                        investigationSiteCode: data.data.site.investigationSiteCode,
                        investigationSiteName: data.data.site.investigationSiteName,
                    })
                },
            };
            AjaxRequest.sendRequest(options);
        }
    }

    disabledDate = (current) => {
        const { planBeginTime, planEndTime } = this.props;
        const planBeginTimeValue = moment(moment(planBeginTime).format('YYYY-MM')).valueOf();
        const planEndTimeValue = moment(moment(planEndTime).format('YYYY-MM')).valueOf();
        const currentValue = moment(current.format('YYYY-MM')).valueOf();
        const nowValue = moment(moment().format('YYYY-MM')).valueOf();
        if (nowValue > planEndTimeValue) {
            return true;
        } else if (nowValue < planBeginTimeValue) {
            return current && (currentValue < planBeginTimeValue || currentValue > planEndTimeValue);
        } else if (nowValue >= planBeginTimeValue && nowValue <= planEndTimeValue) {
            return current && (currentValue < nowValue || currentValue > planEndTimeValue);
        }
    }

    onMonthChange = (index, e) => {
        const { form } = this.props;
        const fteArr = form.getFieldValue('fteArr');
        fteArr[index][0] = e;
        form.setFieldsValue({
            fteArr
        });
    }

    onNumberChange = (index, e) => {
        const { form } = this.props;
        const fteArr = form.getFieldValue('fteArr');
        fteArr[index][1] = e;
        form.setFieldsValue({
            fteArr
        });
    }

    remove = (index) => {
        const { form } = this.props;

        const fteArr = form.getFieldValue('fteArr');
        fteArr.splice(index, 1)

        form.setFieldsValue({
            fteArr
        });
    }

    handleUserChange = (value) => {
        this.props.handleUserChange(value);
    }

    render() {
        const { role, addSelect, selectUserList = [], form } = this.props;
        const { getFieldDecorator, getFieldValue } = form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 20 },
            },
        };
        getFieldDecorator('fteArr', { initialValue: [] });
        getFieldDecorator('keys', { initialValue: 0 });
        getFieldDecorator('ftes', { initialValue: [] });
        getFieldDecorator('FTEDate', { initialValue: [] });
        getFieldDecorator('startMonth', { initialValue: null });
        getFieldDecorator('endMonth', { initialValue: null });
        getFieldDecorator('setFteNum', {
            initialValue: null, rules: [
                {
                    required: true,
                    message: "请输入FTE数量!"
                }
            ]
        });

        const fteArr = getFieldValue('fteArr');
        const keys = getFieldValue('keys');
        const startMonth = getFieldValue('startMonth');
        const endMonth = getFieldValue('endMonth');
        const setFteNum = getFieldValue('setFteNum');

        let invSiteId = getFieldValue('invSiteId');
        if (invSiteId == null || invSiteId == undefined) {
            invSiteId = "";
        }
        let invSiteName = getFieldValue('invSiteName');
        if (invSiteName == null || invSiteName == undefined) {
            invSiteName = "";
        }
        const siteId = sessionStorage.siteId;
        const formItems = fteArr.map((value, fteKey) => {
            let canDateEdit = true;
            let cnaFteEdit = true;
            let canDelete = true;
            if (this.state.mode == 'change') {
                canDelete = false;
                const now = moment(moment().format('YYYY-MM')).format('x');
                if (now > value[0].format('x')) {
                    canDateEdit = false;
                }
                if (now > value[0].format('x')) {
                    cnaFteEdit = false;
                }
                if (now < value[0].format('x')) {
                    canDelete = true;
                } else if (now == value[0].format('x') && this.state.noFte) {
                    canDelete = true;
                }
            }
            return (
                <FormItem
                    {...(fteKey === 0 ? formItemLayout : formItemLayout)}
                    label={fteKey === 0 ? '' : ''}
                    required={false}
                    key={fteKey}
                    style={{ marginLeft: '25px' }}
                >
                    <MonthPicker
                        className="FTETime"
                        format={monthFormat}
                        value={value[0]}
                        disabled={!canDateEdit}
                        style={{ marginLeft: '20px',  width: '100px' }}
                        disabledDate={this.disabledDate}
                        onChange={this.onMonthChange.bind(this, fteKey)}
                    />
                    <InputNumber
                        className="FTENum"
                        placeholder="FTE数量"
                        style={{ width: '80px', marginLeft: '20px' }}
                        value={value[1]}
                        step={0.1}
                        precision={2}
                        onChange={this.onNumberChange.bind(this, fteKey)}
                        formatter={value => value !== value || (!value && value !== 0) ? '' : value}
                        disabled={!cnaFteEdit}
                    />
                    {canDelete &&
                        <Icon
                            className="dynamic-delete-button"
                            type="minus-circle-o"
                            disabled={keys.length === 1}
                            onClick={() => this.remove(fteKey)}
                        />
                    }
                </FormItem>
            )
        })

        let returnStr = '';
        if (siteId != null && siteId != 0) {
            returnStr = (
                <div className="create-form create-require">
                    <Form>
                        <div className="field-max">
                            <div className="ant-row ant-form-item" style={{ marginBottom: '0px' }}>
                                <div className="ant-form-item-label">
                                    <label className="" title={role}>{role}</label>
                                </div>
                                <div className="ant-form-item-control-wrapper" >
                                    <div className="ant-form-item-control ">
                                        <span>
                                            {
                                                this.props.mode == "change" ?
                                                    this.props.editPM
                                                    :
                                                    <Select value={addSelect} style={{ width: 120 }} onChange={this.handleUserChange}>
                                                        {selectUserList.map(user => {
                                                            return <Option value={user.userId}>{user.userCompellation}({user.employeeCode})</Option>
                                                        })}
                                                    </Select>
                                            }
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="field-max">
                            <FormItem label="FTE需求" style={{ marginBottom: '5px' }}>
                                {getFieldDecorator('startMonth', startMonth)(
                                    this.state.mode == "change" ?
                                        <MonthPicker style={{ width: '100px', marginRight: '5px' }} placeholder='起始时间' disabledDate={this.disabledDate} />
                                        :
                                        <MonthPicker style={{ width: '100px', marginRight: '5px' }} placeholder='起始时间' disabledDate={this.disabledDate} />
                                )}
                                -
                                {getFieldDecorator('endMonth', endMonth)(
                                    this.state.mode == "change" ?
                                        <MonthPicker style={{ width: '100px', marginLeft: '5px' }} placeholder='截止时间' disabledDate={this.disabledDate} />
                                        :
                                        <MonthPicker style={{ width: '100px', marginLeft: '5px' }} placeholder='截止时间' disabledDate={this.disabledDate} />
                                )}
                                {getFieldDecorator('setFteNum', setFteNum)(
                                    <InputNumber
                                        className="FTENum"
                                        placeholder="月均FTE数"
                                        style={{ width: "80px", marginLeft: '10px' }}
                                        formatter={value => value !== value ? '' : value}
                                        step={0.1}
                                        precision={2}
                                    />
                                )}
                                <Button onClick={this.add}>添加\更新</Button>
                            </FormItem>
                            <div className="fte-scroll">
                                {formItems}
                            </div>
                        </div>
                    </Form>
                </div>
            )
        } else {
            returnStr = (
                <div className="create-form create-require">
                    <Form>
                        <div className="field-max">
                            <div className="ant-row ant-form-item" style={{ marginBottom: '0px' }}>
                                <div className="ant-form-item-label">
                                    <label className="" title={role}>{role}</label>
                                </div>
                                <div className="ant-form-item-control-wrapper" >
                                    <div className="ant-form-item-control ">
                                        <span>
                                            {
                                                this.props.mode == "change" ?
                                                    this.props.editPM
                                                    :
                                                    <Select value={addSelect} style={{ width: 120 }} onChange={this.handleUserChange}>
                                                        {selectUserList.map(user => {
                                                            return <Option value={user.userId}>{user.userCompellation}({user.employeeCode})</Option>
                                                        })}
                                                    </Select>
                                            }
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="field-max">
                            <FormItem label="FTE需求" style={{ marginBottom: '5px' }}>
                                {getFieldDecorator('startMonth', startMonth)(
                                    this.state.mode == "change" ?
                                        <MonthPicker style={{ width: '100px', marginRight: '5px' }} placeholder='起始时间' disabledDate={this.disabledDate} />
                                        :
                                        <MonthPicker style={{ width: '100px', marginRight: '5px' }} placeholder='起始时间' disabledDate={this.disabledDate} />
                                )}
                                -
                                {getFieldDecorator('endMonth', endMonth)(
                                    this.state.mode == "change" ?
                                        <MonthPicker style={{ width: '100px', marginLeft: '5px' }} placeholder='截止时间' disabledDate={this.disabledDate} />
                                        :
                                        <MonthPicker style={{ width: '100px', marginLeft: '5px' }} placeholder='截止时间' disabledDate={this.disabledDate} />
                                )}
                                {getFieldDecorator('setFteNum', setFteNum)(
                                    <InputNumber
                                        className="FTENum"
                                        placeholder="月均FTE数"
                                        style={{ width: "80px", marginLeft: '10px' }}
                                        formatter={value => value !== value ? '' : value}
                                        step={0.1}
                                        precision={2}
                                    />
                                )}
                                <Button onClick={this.add}>添加\更新</Button>
                            </FormItem>
                            <div className="fte-scroll">
                                {formItems}
                            </div>
                        </div>
                    </Form>
                </div>
            )
        }
        return returnStr;
    }
}

class CreateModal extends Component {
    state = {
        visible: false,
        confirmLoading: false,
        requirement: {},
        site: {},
        isEdit: false,
        invSiteId: '',
        fteList: [],
        requirementId: '',
        mode: 'add',
        noFte: true,
        planBeginTime: null,
        planEndTime: null,
        selectUserList: [],
        editPM: ""
    }

    show = (id, m, record) => {
        const { role } = this.props;
        this.setState({
            visible: true,
            isEdit: false,
            requirement: {},
            requirementId: '',
            site: {},
            invSiteId: '',
            fteList: [],
            city: '',
            planBeginTime: this.props.planBeginTime,
            planEndTime: this.props.planEndTime,
        });
        if (id) {
            this.setState({
                isEdit: true,
                requirementId: record.requirementId,
                mode: "change",
                fteList: (record && record.fteList) || [],
                editPM: `${record.userCompellation}(${record.employeeCode})`,
                addSelect: record.userId,
            });
        } else {
            this.setState({
                mode: 'add',
            });
        }

        AjaxRequest.sendRequest({
            url: role === 'PA' ? `${API_URL.site.queryInvestigationPaList}` : `${API_URL.site.queryPMLeaderAddAndModify}`,
            dataType: 'json',
            doneResult: res => {
                if (!id) {
                    this.setState({
                        selectUserList: res.datas,
                        addSelect: res.datas && res.datas[0] &&res.datas[0].userId,
                    })
                } else {
                    this.setState({
                        selectUserList: data.datas,
                    })
                }
            },
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    // 提交表单
    handleSubmit = () => {
        this.refs.form.validateFieldsAndScroll((errors, values) => {
            if (errors) {
                return;
            }
            const fieldsValue = this.refs.form.getFieldsValue();
            const fteArr = fieldsValue.fteArr;

            const { role } = this.props;
            const { isEdit, addSelect, requirementId } = this.state;
            if (!addSelect) {
                message.warning(`请选择${role}！`);
                return;
            }
            
            let needData = 0;
            let needNumber = 0;
            fteArr.map((value, index) => {
                if (value[0] === null || value[0] === undefined) {
                    needData++;
                }
                if (value[1] === null || value[1] === undefined) {

                    needNumber++
                }
            })
            if (needData > 0) {
                Modal.error({ title: "尚有日期未选择" });
                return;
            }
            if (needNumber > 0) {
                Modal.error({ title: "尚有FTE数量未填写" });
                return;
            }
            let ftesStr = '';
            fteArr.map((value, index) => {
                const year = value[0].format("YYYY");
                const month = value[0].format("MM");
                const fteNum = value[1];
                ftesStr += "&ftes[" + index + "].year=" + year;
                ftesStr += "&ftes[" + index + "].month=" + month;
                ftesStr += "&ftes[" + index + "].fte=" + fteNum;
            });

            let invSiteId = fieldsValue.invSiteId;
            if (invSiteId == null || invSiteId == undefined) {
                invSiteId = sessionStorage.siteId;
            }
            let comment = {};
            let param = "invSiteId=" + invSiteId;
            if (fieldsValue.comment != null && fieldsValue.comment != undefined) {
                comment.comment = fieldsValue.comment;
            }
            if (ftesStr != "") {
                param += ftesStr;
            }

            this.setState({ loading: true });
            if (isEdit) {
                comment.userId = addSelect;
                let options = {};
                param += "&requirementId=" + requirementId;
                // 修改
                options = {
                    method: 'POST',
                    url: `${API_URL.plan.modifyPmPlanFte}?${param}`,
                    data: {
                        ...comment,
                        roleCode: role,
                    },
                    doneResult: () => {
                        message.success('修改成功');
                        this.hide();
                        this.setState({ loading: false }, () => {
                            this.props.reload();
                        });
                    },
                    errorResult: () => {
                        this.setState({ loading: false });
                    }
                };
                AjaxRequest.sendRequest(options);
            } else {
                // 新建
                comment.userId = addSelect;
                const options = {
                    method: 'POST',
                    url: `${API_URL.plan.addPmPlanFte}?${param}`,
                    data: {
                        ...comment,
                        roleCode: role,
                    },
                    doneResult: () => {
                        message.success('新建成功');
                        this.hide();
                        this.setState({ loading: false }, () => {
                            this.props.reload();
                        });
                    },
                    errorResult: () => {
                        this.setState({ loading: false });
                    }
                };
                AjaxRequest.sendRequest(options);
            }
        });
    }

    handleUserChange = (value) => {
        this.setState({
            addSelect: value
        })
    }

    render() {
        const { role } = this.props;
        const { loading, visible, addSelect, selectUserList, editPM, requirement, site, fteList, isEdit, noFte, planEndTime, planBeginTime } = this.state;
        const mapPropsToFields = () => ({
            invSiteId: { value: site.investigationSiteId },
            comment: { value: requirement.requirementComment },
            invSiteName: { value: site.investigationSiteName },
        });
        CreateForm = Form.create({ mapPropsToFields })(CreateForm);
        return (
            <Modal
                title={isEdit ? "调整计划" : "添加计划"}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="create-modal requirement-create"
                wrapClassName="vertical-center-modal create-require-modal"
                width="650px"
                confirmLoading={loading}
                maskClosable={false}
            >
                <CreateForm
                    ref="form"
                    mode={this.state.mode}
                    planBeginTime={planBeginTime}
                    planEndTime={planEndTime}
                    noFte={noFte}
                    fteList={fteList}
                    handleUserChange={this.handleUserChange}
                    addSelect={addSelect}
                    selectUserList={selectUserList}
                    editPM={editPM}
                    role={role}
                />
            </Modal>
        );
    }
}

export default CreateModal;


// WEBPACK FOOTER //
// ./src/components/plan/AddPmFte.js